import type { FieldFormatter } from 'models/forms/fields/utils';

import type { FieldMetadataBase } from './FieldMetadataBase';

export type AmountFieldData = number;

export type AmountFieldMetadata = FieldMetadataBase<'AmountField', AmountFieldData> & {
  nbDecimals: number;
  decimalPadding?: boolean;
  currency: string;
  hasTooltip?: boolean;
};

export const amountFieldFormatter: FieldFormatter<AmountFieldMetadata> = {
  isHandled: field => field.type === 'AmountField',
  format(field) {
    return { ...field, currency: '-' };
  },
};
